/*
Author: Vinod
Date: 09/12//2019
Issue Description: Under this head only the Fixed Non-CTC Components should be displayed. Currently, even the variable earnings are being displayed
search_string: PL_2241
*/

/*
Author: Vinod
Date: 24/03/2020
Issue: After Adding Employees Getting error message in UI "QuotaExceededError: Failed to execute 'setItem' on 'Storage': Setting the value of 'vuex' exceeded the quota '.
search_string: PL_2978
*/

import {
  get_axios_instance,
  get_axios_instance_absolute_path,
  api_variables,
  get_axios_file_instance,
  errorHandler
} from "@/apis/variables.js";
//    SERVICE_UPLOAD_LOP_RLOP: "/employee",
var axios_instance_upload_template = get_axios_file_instance(
  api_variables.SERVICE_BULK_UPLOAD_EMPLOYEE
);
var axios_instance = get_axios_instance(api_variables.SERVICE_GET_EMPLOYEE1);
var axios_generate_code = get_axios_instance(
  api_variables.SERVICE_GENERATE_CODE
);
var axios_instance_create = get_axios_instance(
  api_variables.SERVICE_SAVE_EMPLOYEE
);
var search_emp_axios_instance = get_axios_instance(
  api_variables.SERVICE_EMPLOYEE_SEARCH_BY_NAME
);
var get_emp_by_id_axios_instance = get_axios_instance(
  api_variables.SERVICE_GET_EMPLOYEE_BY_ID
);
var axios_instance_update = get_axios_instance(
  api_variables.SERVICE_UPDATE_EMPLOYEE
);
var axios_instance_fixed_non_ctc = get_axios_instance(
  api_variables.SERVICE_EMPLOYEE_NON_CTC_COMP
); //PL_2241
var axios_instance_enable_ess = get_axios_instance(
  api_variables.SERVICE_ENABLE_ESS
);
var axios_instance_employee_list_ess = get_axios_instance(
  api_variables.SERVICE_EMPLOYEE_LIST_ESS
);
var axios_instance_employee_salary_revision = get_axios_instance(
  api_variables.SERVICE_EMPLOYEE_SALARY_REVISION
);
var axios_instance_employee_salary_details = get_axios_instance(
  api_variables.SERVICE_EMPLOYEE_SALARY_DETAILS
);
const _pk_name = "id";
var axios_employee_template = get_axios_instance(api_variables.SERVICE_EPLOYEE_UPLOAD_TEMPLATE);

var axios_employee_code_download_template = get_axios_instance(api_variables.SERVICE_DOWNLOAD_EMPLOYEE_CODE_TEMPLATE);
var axios_instance_bulk_upload_employee_code = get_axios_instance(api_variables.SERVICE_EMPLOYEE_CODE_BULK_UPLOAD);
var axios_employee_proxy = get_axios_instance(api_variables.SERVICE_DOWNLOAD_EMPLOYEE_PROXY);

const state = {
  data: {},
  unsavedEmployeeData: null,
  isFetching: false,
  isSaving: false,
  isDeleting: false,
  editMode: false,
  record: []
};

// const getters = {
//   editMode:(state) =>{
//     return state.editMode;
//   },
//   record: (state) => {
//     return state.record
//   }
// }

const mutations = {
  set: (state, [payload, id]) => {
    state.data[id] = payload;
    state.data = { ...state.data };
  },

  setUnsavedEmpData: (state, payload) => {
    // state.unsavedEmployeeData = null;
    state.unsavedEmployeeData = payload;
  },

  setempObj: (state, payload) => {
    state.record = payload;
  },

  addEntity: (state, [payload, id]) => {
    if (!state.data[id]) {
      state.data[id] = [...payload];
    } else {
      state.data[id].push(payload);
    }
  },

  updateEntityById: (state, [payload, id]) => {
    for (let i = 0; i < state.data[id].length; i++) {
      if (state.data[id][i][_pk_name] === payload.id) {
        state.data[id].splice(i, 1, payload);
      }
    }
  },

  removeEntityById: (state, [id, leid]) => {
    for (let i = 0; i < state.data[leid].length; i++) {
      if (state.data[leid][i][_pk_name] == id) {
        state.data[leid].splice(i, 1);
      }
    }
    if (state.data[leid].length == 0) state.data = {};
  }
};

const actions = {
  async uploadTemplate({ commit }, payload) {
    try {
      let res = await axios_instance_upload_template.post(``, payload);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async fetchBySearch({ commit }, searchText) {
    try {
      let res = await search_emp_axios_instance.get("/?key=" + searchText);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  // Start PL_2241
  async fetchAllNonCTCcomponents({ commit }, payload) {
    try {
      let res = await axios_instance_fixed_non_ctc.get(``, {
        params: {
          le_id: payload,
        },
      });
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  // End PL_2241

  async fetchAll({ commit }, payload) {
    try {
      // commit("setFetching", true);
      let res = await axios_instance.get(`?page=${payload.page}`, {
        params: {
          le_id: payload.le_id,
          financial_year: payload.financial_year,
        },
      });
      // PL_2978
      // commit("setFetching", false);
      // if (res.status == 200) {
      //   commit("set", [res.data.payload.data, payload]);
      // }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async fetchEmployeeListESS({ commit }, payload) {
    try {
      let res = await axios_instance_employee_list_ess.get(`/`, {
        params: {
          le_id: payload.le_id,
        },
      });
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async fetchEmployeeSalaryRevision({ commit }, payload) {
    try {
      let res = await axios_instance_employee_salary_revision.get(`/`, {
        params: {
          le_id: payload.le_id,
          empId: payload.emp_id,
          page: 1,
        },
      });
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async fetchEmployeeSalaryDetail({ commit }, payload) {
    try {
      let res = await axios_instance_employee_salary_details.get(`/`, {
        params: {
          le_id: payload.le_id,
          empId: payload.emp_id,
        },
      });
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async fetchEmpDataById({ commit }, payload) {
    try {
      let res = await get_emp_by_id_axios_instance.get(
        `/${payload.empId}/legal_entity/${payload.empLeId}`
      );
      commit("setempObj", res.data.payload.emp);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async fetchEmployeeCode({ commit }, payload) {
    try {
      let res = await axios_generate_code.get("", {
        params: {
          le_id: payload,
        },
      });
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },
  async create({ commit }, payload) {
    try {
      let res = await axios_instance_create.post("/", payload);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async createEss({ commit }, payload) {
    try {
      let res = await axios_instance_enable_ess.post("/", payload);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async storeUnsavedEmployeeData({ commit }, payload) {
    try {
      commit("setUnsavedEmpData", payload);
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async update({ commit }, payload) {
    try {
      let res = await axios_instance_update.put(``, payload);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async deletee({ commit }, [id, leid]) {
    try {
      let res = await axios_instance_create.delete(`/${id}`);
      if (res.status == 200) {
        commit("removeEntityById", [id, leid]);
      }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async getUploadErrorLog({ commit }, url) {
    try {
      let axios_employee_log = get_axios_instance(url);
      let res = await get_axios_instance_absolute_path.get("/");

      if (res.data.status) {
        const link = document.createElement("a");
        //console.log(res);
        link.href = res.data.payload.Location;
        link.setAttribute("download", "employeeErrorLog" + ".txt"); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    } catch (err) {
      throw errorHandler(error.response);
    }
  },

  async getEmployeeTemplate({ commit }, leId) {
    try {
      //console.log("Inside Report.js");
      let res = await axios_employee_template.get(`/${leId}`);
      //console.log({res});

      if (res.data.status) {
        const link = document.createElement("a");
        //console.log(res);
        link.href = res.data.payload;
        link.setAttribute("download", "employeeTemplate" + ".xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    } catch (err) {
      throw errorHandler(error.response);
    }
  },

  async getEmployeeCodeTemplate({ commit }, payload) {
    try {
      let res = await axios_employee_code_download_template.get(`/`, {
        params: {
          le_id: payload,
        },
      });

      if (res.data.status) {
        const link = document.createElement("a");
        //console.log(res);
        link.href = res.data.payload;
        link.setAttribute("download", "employeeCodeTemplate" + ".xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    } catch (err) {
      throw errorHandler(error);
    }
  },

  async uploadCodeTemplate({ commit }, payload) {
    try {
        // commit("setFetching", true);
        let res = await axios_instance_bulk_upload_employee_code.post(``,payload);
        // commit("setFetching", false);
        return res;
    } catch (err) {
        throw errorHandler(err.response);
    }
},

async getProxy({ commit }, payload) {
  try {
      let res = await axios_employee_proxy.post(`?identity=${payload.identity}&companyCode=${payload.companyCode}`);
      return res;
  } catch (err) {
      throw errorHandler(err.response);
  }
},
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
